export default __webpack_public_path__ + "static/media/learn_bg_bottom_right.0a520d7e.png";